import ActivitySummaryView from '@/ux/views/activities/ActivitySummaryView.vue';
import ActivityDetailView from '@/ux/views/activities/ActivityDetailView.vue';
import ActivityTabView from '@/ux/views/activities/ActivityTabView.vue';
import ActivityBottomNavView from '@/ux/views/activities/ActivityBottomNavView.vue';
import ActivitySegmentsView from '@/ux/views/activities/ActivitySegmentsView.vue';
import ElevationProfile from '@/ux/views/activities/ActivityElevationView.vue';
import ActivityMonthSummaryView from '@/ux/views/activities/ActivityMonthSummaryView.vue';

export default
[
    {
        path: '/activities/summary/:sort/:direction',
        name: 'activitySummary',
        component: ActivitySummaryView,
        props: true,
    },
    {
        path: '/activity/:id',
        name: 'activity',
        component: ActivityDetailView,
        props: true,
    },
    {
        path: '/activity/tabs/:id',
        name: 'activityTabs',
        component: ActivityTabView,
        props: true,
        meta: {
        },
    },
    {
        path: '/activity/bnav/:id',
        name: 'activityBottomNav',
        component: ActivityBottomNavView,
        props: true,
        meta: {
        },
    },
    {
        path: '/activity/:id/segments',
        name: 'activitySegmentEfforts',
        component: ActivitySegmentsView,
        props: true,
    },
    {
        path: '/activity/:id/profile',
        name: 'activityProfile',
        component: ElevationProfile,
        props: true,
    },
    {
        path: '/activity/months/summary-table',
        name: 'activityMonthSummaryView',
        component: ActivityMonthSummaryView,
        props: true,
    },
];
